
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.312","height":"21.974","viewBox":"0 0 18.312 21.974"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.565 1.831c-1.125 0-2-.992-2.747-1.831H5.493c-.75.839-1.621 1.831-2.746 1.831H0v20.143h18.312V1.831zm-6.409 0a.916.916 0 11-.916.916.916.916 0 01.916-.916zm7.324 18.312h-3.5a23 23 0 003.5-3.539zm0-7.743c0 3.76-5.493 2.25-5.493 2.25s1.39 5.494-2.415 5.494H1.831V3.662h3.662l1.925 1.831h3.569l1.831-1.831h3.662z"}})])
          )
        }
      }
    